import { compareNaturalStrings } from './naturalStringCompare';

declare global {
  interface JQuery {
    fn: JQuery & {
      dataTable?: {
        ext: {
          type: {
            order: Record<string, (a: unknown, b: unknown) => number>;
          };
        };
      };
    };
  }
}

/** DataTables 列 type: natural-ja 用（ケース名 1,2,10,11 等） */
export function ensureDataTablesNaturalJaSort(): void {
  if (typeof window === 'undefined') return;
  const $ = window.jQuery;
  const ext = $?.fn?.dataTable?.ext;
  if (!ext) return;
  if (ext.type.order['natural-ja-asc']) return;
  ext.type.order['natural-ja-asc'] = (a: unknown, b: unknown) =>
    compareNaturalStrings(String(a ?? ''), String(b ?? ''));
  ext.type.order['natural-ja-desc'] = (a: unknown, b: unknown) =>
    -compareNaturalStrings(String(a ?? ''), String(b ?? ''));
}
